import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import {
  debounceTime,
  distinctUntilChanged,
  firstValueFrom,
  from,
  of,
  switchMap,
} from 'rxjs';
import { ChronicCondition } from 'app/core/models/chronic-condition/chronic-condition.model';
import { FormGroup } from '@angular/forms';
import { ApiService } from '../api/api.service';
import { BaseApiResponse } from 'app/core/models/api/api.model';

@Injectable({
  providedIn: 'root',
})
export class ChronicConditionService {
  constructor(private apiService: ApiService) {}
  userLang = localStorage.getItem('app-lang') || 'en-US';

  async searchChronicConditionsQuery(
    searchTerm: string,
    pageIndex: number = 0,
    pageSize: number = 10
  ): Promise<BaseApiResponse<ChronicCondition[]>> {
    return await firstValueFrom(
      this.apiService.get<ChronicCondition[]>(
        `${environment.apiLocations.patient}/chroniccondition/search-chronic-conditions?query=${searchTerm}&pageIndex=${pageIndex}&pageSize=${pageSize}&lang=${this.userLang}`
      )
    );
  }

  setupSearchTermListener(
    form: FormGroup,
    propName: string,
    callBack: (res: BaseApiResponse<ChronicCondition[]>) => void,
    errCallBack: () => void
  ) {
    form
      .get(propName)
      ?.valueChanges.pipe(
        debounceTime(1000),
        distinctUntilChanged(),
        switchMap((term) => {
          const trimmed = term?.trim();
          if (!trimmed) {
            return of({
              data: [],
              fail: false,
              Errors: [],
            } as BaseApiResponse<ChronicCondition[]>);
          }
          return from(this.searchChronicConditionsQuery(trimmed));
        })
      )
      .subscribe({
        next: (res) => {
          callBack(res);
        },
        error: () => errCallBack(),
      });
  }

  selectItem(
    form: FormGroup,
    propName: string,
    item: ChronicCondition,
    chronicConditionArray: ChronicCondition[],
    callBack: () => void
  ) {
    form.get(propName)!.setValue(`${item.code} - ${item.name}`);
    chronicConditionArray.push(item);
    form.get(propName)!.setValue('');
    callBack();
  }

  removeCondition(index: number, chronicConditionArray: ChronicCondition[]) {
    chronicConditionArray.splice(index, 1)[0];
  }
}
